import { Group, Image, Title } from "@mantine/core";
import { getLogoConfig } from "../config/navigation";
import classes from "./Logo.module.css";
import { useNavigation } from "@/hooks/useNavigation";

export interface LogoProps {
  className?: string;
  showTitle?: boolean;
}

export default function Logo({ className, showTitle = true }: LogoProps) {
  const { handleLogoClick } = useNavigation();
  const logoConfig = getLogoConfig();

  return (
    <Group
      onClick={handleLogoClick}
      className={`${classes.logo} ${className || ""}`}
      gap={"sm"}
      wrap="nowrap"
    >
      <Image src={logoConfig.src} alt={logoConfig.alt} w={48} h={48} />
      {showTitle && (
        <Title order={1} className={classes.brand} visibleFrom="sm">
          Anchor
        </Title>
      )}
    </Group>
  );
}
